import { render } from "./HelloWorld.vue?vue&type=template&id=b1dfe1a6&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=b1dfe1a6&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-b1dfe1a6"

export default script